import { createApp } from '@app/adapters/create-app'

import WorkflowReviewBreadcrumb from '@app/application/workflows/screens/workflow-review/components/workflow-review-breadcrumb.vue'
import type { BreadcrumbItem } from '@app/shared/vue/components/sf-breadcrumbs/types'

window.onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='workflow-review-breadcrumb']").each(function () {
    const staticItems = JSON.parse(
      this.dataset.items ?? '[]'
    ) as BreadcrumbItem[]

    createApp(WorkflowReviewBreadcrumb, { staticItems }).mount(this)
  })
})
